import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { AppState } from 'src/app/store/app.state';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ModalService } from 'src/app/services/modal.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  form: FormGroup;

  ngUnsubscribe = new Subject()
  
  show: boolean = false;

  constructor(
    private fb: FormBuilder,
    private store: Store<AppState>,
    private router: Router,
    private authService: AuthService,
    private modalService: ModalService
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    })
  }

  login(){
    const payload = {
      username: this.username?.value,
      password: this.password?.value,
    }

    this.authService.logIn(payload).toPromise().then((res) => {
      if(res){
        this.modalService.hideLogin();
        this.router.navigateByUrl('/home');
      }
    }).catch((err) => {
      const error = {
        message: err?.error?.message
      }
      this.modalService.errorModal(error);
    })
  }

  get username(){
    return this.form.get('username');
  }

  get password(){
    return this.form.get('password');
  }

  showPassword() {
    this.show = !this.show;
  }
}
